import {
  FormHelperText,
  IconButton,
  TextField,
  Typography
} from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import VisibilityIcon from "@material-ui/icons/Visibility";
import ContentTitle from "components/common/ContentTitle";
import Steper from "components/common/Steper";
import ButtonController from "components/request-document/components/ButtonController";
import {
  Bagde,
  StyleCheckbox,
  StyledTableCell,
  TableRowHead,
  UploadButton,
  useStyles
} from "components/request-document/components/Commons";
import CompanyInfoSection from "components/request-document/components/CompanyInfoSection";
import { useFormik } from "formik";
import {
  REQUEST_DOCUMENT_STEP,
  RoleId,
  STATUS_PROCESS
} from "libs/configs/constant";
import { SMART_T_STEP } from "libs/constant/Step";
import useModalLoading from "libs/hooks/useModalLoading";
import { openFileById } from "libs/utils/file";
import { getErrorMessage, isError } from "libs/utils/form";
import { get } from "lodash-es";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { canEditForm } from "redux/modules/authSlice";
import { getMasterData, selectMasterData } from "redux/modules/masterSlice";
import { selectPersonalDetail } from "redux/modules/personalSlice";
import { setSmartFormStep } from "redux/modules/uiSlice";
import {
  addSmartForm,
  addSmartFormSlice,
  getSmartForm,
  getSmartFormFieldConfig,
  selectAddSmartForm,
  selectCurrentSmartForm,
  selectCurrentSmartServiceId,
  selectDraftId,
  selectSmartFormFieldConfig
} from "redux/modules/visaForm";
import AllDocumentsService from "services/AllDocumentsService";
import FileService from "services/FileService";
import * as yup from "yup";

export default function UserProfileStepB() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { showLoading, hideLoading } = useModalLoading();
  const [isSaveDraft, setSaveDraft] = useState(false);
  const canEdit = useSelector(canEditForm);
  const personalDetail = useSelector(selectPersonalDetail);
  const smartServiceId = useSelector(selectCurrentSmartServiceId);
  const draftId = useSelector(selectDraftId);
  const masterData = useSelector(selectMasterData);
  const smartFormFieldConfig = useSelector(selectSmartFormFieldConfig);
  const addSmartFormState = useSelector(selectAddSmartForm);
  const smartform = useSelector(selectCurrentSmartForm);

  const personalId = get(personalDetail, "personalID", "");
  const activitiesConfig = get(masterData, "activitiesConfig", []);
  const assignmentConfig = get(masterData, "assignmentConfig", []);
  const technologyCoreConfig = get(masterData, "technologyCoreConfig", []);
  const technologyEmploymentConfig = get(
    masterData,
    "technologyEmploymentConfig",
    []
  );

  const { role } = useSelector((state) => state.auth);
  const { draftId: draftIdSelected } = useSelector(
    (state) => state.allDocuments.detail
  );
  const history = useHistory();

  const approveDoc = async () => {
    if (!window.confirm("Do you want to approve document?")) {
      return;
    }

    showLoading();

    const response = await AllDocumentsService.approveDoc(draftIdSelected);
    hideLoading();
    if (response.status) {
      history.push(`/admin/smart-visa/all-documents`);
    }
  };

  const detailList = [
    "CompanyRegisterNumber",
    "CompanyName",
    "CompanyAddress",
    "OfficeNumber",
    "CompanyWebSite",
    "ProductService",
    "MajorService",
    "SaleRevenune",
    "activitiesId",
    "activitiesIdSub",
    "Explanation",
    "ProcessDiagram",
    "assignmentId",
    "AmountofShare",
    "ValuePerShare",
    "SharesOwned",
    "technologyCore",
    "technologyCoreExplain",
    "technologyEmployment",
    "technologyEmploymentExplain",
  ];
  const smartNameById = (p, c) => ({ ...p, [c.smartName]: c });
  const detail = get(smartform, "detail", [])
    .filter((field) => detailList.includes(field.smartName))
    .reduce(smartNameById, {});

  useEffect(() => {
    dispatch(
      getMasterData({
        ActivitiesConfig: true,
        AssignmentConfig: true,
        technologyCoreConfig: true,
        technologyEmploymentConfig: true,
      })
    );
  }, [dispatch]);

  useEffect(() => {
    if (smartServiceId) {
      dispatch(getSmartFormFieldConfig({ smartserviceId: smartServiceId }));
      dispatch(
        getSmartForm({
          smartserviceId: smartServiceId,
          draftId,
          personalId,
        })
      );
    }
  }, [dispatch, draftId, personalId, smartServiceId]);

  useEffect(() => {
    if (!addSmartFormState.isLoading) {
      if (addSmartFormState.isSuccess) {
        hideLoading();
        dispatch(addSmartFormSlice.actions.clearAsyncState());

        if (!isSaveDraft) {
          dispatch(setSmartFormStep(SMART_T_STEP.VISA_INSUANCE));
        } else {
          dispatch(
            getSmartForm({
              smartserviceId: smartServiceId,
              draftId,
              personalId,
            })
          );
        }
      } else if (addSmartFormState.isFailure) {
        hideLoading();
        alert(addSmartFormState.error?.message);
        dispatch(addSmartFormSlice.actions.clearAsyncState());
      }
    }
  }, [
    addSmartFormState,
    dispatch,
    draftId,
    hideLoading,
    isSaveDraft,
    personalId,
    smartServiceId,
  ]);

  const callAPISubmit = async (values) => {
    showLoading();

    const defaultType = get(smartFormFieldConfig, "data.defaultType", []);
    const documentFields = Object.keys(values);
    const getFieldListConfig = defaultType.filter((field) =>
      documentFields.includes(field.smartName)
    );

    const getValue = (field) => {
      switch (field.smartName) {
        case "ProcessDiagram": {
          const FileID = values?.ProcessDiagram?.FileID;
          if (!FileID) return null;
          return {
            ext: values?.ProcessDiagram?.ext || null,
            FileID: values?.ProcessDiagram?.FileID || null,
            filename: values?.ProcessDiagram?.filename || null,
            processfileID: values?.ProcessDiagram?.processfileID || null,
            Status: values?.ProcessDiagram?.Status || true,
          };
        }
        default:
          return get(values, `${field.smartName}`, null);
      }
    };

    const getSmartId = (field) =>
      get(detail, `${field.smartName}.smartId`, null);

    const prepareData = {
      draftId: draftId || null,
      smartserviceId: smartServiceId,
      personalId: personalId,
      survey: null,
      visaissuance: null,
      detail: [
        ...getFieldListConfig.map((field) => ({
          smartName: field.smartName,
          smartId: getSmartId(field),
          partfromId: field.partfromId,
          configsmartId: field.configsmartId,
          linkTable: field.linkTable,
          value: getValue(field),
        })),
      ],
    };

    await dispatch(
      addSmartForm({
        data: prepareData,
      })
    );
  };
  const defaultProcessDiagram = get(detail, "ProcessDiagram.value", "");
  const isDraftDocument = smartform?.statausID === STATUS_PROCESS.Draft;
  const validationSchema = yup.object({});
  const formik = useFormik({
    enableReinitialize: true,
    validationSchema: isDraftDocument ? validationSchema : yup.object({}),
    initialValues: {
      CompanyRegisterNumber: get(detail, "CompanyRegisterNumber.value", ""),
      CompanyName: get(detail, "CompanyName.value", ""),
      CompanyAddress: get(detail, "CompanyAddress.value", ""),
      OfficeNumber: get(detail, "OfficeNumber.value", ""),
      CompanyWebSite: get(detail, "CompanyWebSite.value", ""),
      ProductService: get(detail, "ProductService.value", ""),
      MajorService: get(detail, "MajorService.value", ""),
      SaleRevenune: get(detail, "SaleRevenune.value", ""),
      activitiesId: get(detail, "activitiesId.value", ""),
      activitiesIdSub: get(detail, "activitiesIdSub.value", ""),
      assignmentId: get(detail, "assignmentId.value", ""),
      ProcessDiagram: {
        ext: defaultProcessDiagram.ext,
        FileID: defaultProcessDiagram.fileID,
        filename: defaultProcessDiagram.fileID,
        processfileID: defaultProcessDiagram.fileID,
        Status: defaultProcessDiagram.status || true,
      },
      Explanation: get(detail, "Explanation.value", ""),
      AmountofShare: get(detail, "AmountofShare.value", ""),
      ValuePerShare: get(detail, "ValuePerShare.value", ""),
      SharesOwned: get(detail, "SharesOwned.value", ""),
      technologyCore: get(detail, "technologyCore.value", ""),
      technologyCoreExplain: get(detail, "technologyCoreExplain.value", ""),
      technologyEmployment: get(detail, "technologyEmployment.value", ""),
      technologyEmploymentExplain: get(
        detail,
        "technologyEmploymentExplain.value",
        ""
      ),
    },
    onSubmit: async (values) => {
      setSaveDraft(false);
      callAPISubmit(values);
    },
  });
  const Role = useSelector((e) => {
    return e.user.profile.roleId;
  });
  // Disabled all field if status != draft
  if (!isDraftDocument && Role !== RoleId.Admin) {
    formik.handleBlur = () => {};
    formik.handleChange = () => {};
    formik.setFieldValue = () => {};
  }

  return (
    <div className={classes.root}>
      <form onSubmit={formik.handleSubmit}>
        <ContentTitle
          title="Application Form"
          subTitle="APPLICATION FOR QUALIFICATION ENDORSEMENT FOR SMART VISA “I”"
        />
        <Steper currentStep={1} stepInfo={REQUEST_DOCUMENT_STEP} />
        <TableContainer style={{ marginTop: 35, borderRadius: 4 }}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <StyledTableCell colSpan={4}>
                  <Typography variant="h6" className={classes.tableTitle}>
                    FORM A
                  </Typography>
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <CompanyInfoSection formik={formik} />

              <TableRow>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <Bagde number={6} />
                    <div className={classes.wrapField}>
                      <InputLabel>
                        Business or products or services description
                      </InputLabel>
                      <TextField
                        disabled={!canEdit}
                        variant="outlined"
                        className={classes.textField}
                        name="ProductService"
                        value={formik.values.ProductService}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("ProductService", formik)}
                        helperText={getErrorMessage("ProductService", formik)}
                        multiline
                        rows={5}
                        rowsMin={5}
                        rowsMax={5}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRowHead>
                <StyledTableCell colSpan={2}>
                  <div className={classes.cellContent}>
                    <Bagde number={7} />
                    <div className={classes.wrapField}>
                      <InputLabel>Major products or services</InputLabel>
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell>
                  <div className={classes.cellContent}>
                    <Bagde number={0} />
                    <div className={classes.wrapField}>
                      <InputLabel>
                        Sale revenue (Approximate in Baht)
                      </InputLabel>
                    </div>
                  </div>
                </StyledTableCell>
              </TableRowHead>
              <TableRow>
                <StyledTableCell colSpan={2}>
                  <TextField
                    disabled={!canEdit}
                    variant="outlined"
                    className={classes.textField}
                    name="MajorService"
                    value={formik.values.MajorService}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={isError("MajorService", formik)}
                    helperText={getErrorMessage("MajorService", formik)}
                    multiline
                    rows={5}
                    rowsMin={5}
                    rowsMax={5}
                  />
                </StyledTableCell>
                <StyledTableCell>
                  <TextField
                    disabled={!canEdit}
                    variant="outlined"
                    className={classes.textField}
                    name="SaleRevenune"
                    value={formik.values.SaleRevenune}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={isError("SaleRevenune", formik)}
                    helperText={getErrorMessage("SaleRevenune", formik)}
                    multiline
                    rows={5}
                    rowsMin={5}
                    rowsMax={5}
                  />
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colSpan={2}>
                  <div className={classes.cellContent}>
                    <Bagde number={8} />
                    <div className={classes.wrapField}>
                      <InputLabel>
                        Please choose the targeted industries most relevant to
                        your company’s activities
                      </InputLabel>
                      <FormControl
                        variant="outlined"
                        className={classes.formControl}
                        fullWidth
                        style={{ width: 500 }}
                      >
                        <InputLabel>Activities</InputLabel>
                        <Select
                          disabled={!canEdit}
                          label="Activities"
                          name="activitiesId"
                          value={formik.values.activitiesId}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        >
                          {activitiesConfig.map((activities) => (
                            <MenuItem
                              key={activities.activitiesId}
                              value={activities.activitiesId}
                            >
                              {activities.activitiesName}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell colSpan={1}>
                  <div className={classes.cellContent}>
                    <div className={classes.wrapField}>
                      <InputLabel>Sub activities</InputLabel>
                      <FormControl
                        variant="outlined"
                        className={classes.formControl}
                        fullWidth
                        style={{ width: 350 }}
                      >
                        <InputLabel>Sub activities</InputLabel>
                        <Select
                          disabled={!canEdit}
                          label="Sub activities"
                          name="activitiesIdSub"
                          value={formik.values.activitiesIdSub}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        >
                          {activitiesConfig.map((activities) => (
                            <MenuItem
                              key={activities.activitiesId}
                              value={activities.activitiesId}
                            >
                              {activities.activitiesName}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRowHead>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <Bagde number={9} />
                    <div className={classes.wrapField}>
                      <InputLabel>
                        Manufacturing/Service Process. Please provide a process
                        diagram that explains the manufacturing/service process
                        (additional documents can be attached).
                      </InputLabel>
                    </div>
                  </div>
                </StyledTableCell>
              </TableRowHead>
              <TableRowHead>
                <StyledTableCell colSpan={2} align="center">
                  <InputLabel>Process Diagram</InputLabel>
                </StyledTableCell>
                <StyledTableCell align="center">
                  <InputLabel>Explanation</InputLabel>
                </StyledTableCell>
              </TableRowHead>
              <TableRow>
                <StyledTableCell colSpan={2}>
                  <div className={classes.flexRow}>
                    <InputLabel>File Upload ( PDF, JPG )</InputLabel>
                    <div style={{ width: 18 }} />
                    <UploadButton
                      disabled={!canEdit}
                      title={
                        get(formik.values, `ProcessDiagram.FileID`, "")
                          ? "Edit"
                          : "+ Add"
                      }
                      id={`upload-ProcessDiagram`}
                      onChange={async (event) => {
                        try {
                          const response = await FileService.uploadFile({
                            file: event.target.files[0],
                            Status: true,
                          });
                          const fileId = response.results?.fileID;
                          const [filename, ext] =
                            event.target.files[0].name.split(".");

                          formik.setFieldValue(`ProcessDiagram`, {
                            processfileID: fileId,
                            FileID: fileId,
                            filename,
                            ext,
                            Status: true,
                          });
                        } catch (error) {
                          console.log("Upload error", error);
                        }
                      }}
                    />
                    {get(formik.values, `ProcessDiagram.FileID`, "") && (
                      <IconButton
                        style={{ width: 40 }}
                        size="small"
                        onClick={async () => {
                          const processfileID = get(
                            formik.values,
                            `ProcessDiagram.FileID`,
                            ""
                          );

                          openFileById(processfileID);
                        }}
                      >
                        <VisibilityIcon />
                      </IconButton>
                    )}
                  </div>
                </StyledTableCell>
                <StyledTableCell>
                  <TextField
                    disabled={!canEdit}
                    variant="outlined"
                    className={classes.textField}
                    name="Explanation"
                    value={formik.values.Explanation}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={isError("Explanation", formik)}
                    helperText={getErrorMessage("Explanation", formik)}
                    multiline
                    rows={10}
                  />
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell>
                  <div className={classes.cellContent}>
                    <Bagde number={10} />
                    <div className={classes.wrapField}>
                      <InputLabel>Amount of share (Baht)</InputLabel>
                      <TextField
                        disabled={!canEdit}
                        variant="outlined"
                        className={classes.textField}
                        name="AmountofShare"
                        value={formik.values.AmountofShare}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("AmountofShare", formik)}
                        helperText={getErrorMessage("AmountofShare", formik)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell>
                  <div className={classes.cellContent}>
                    <Bagde number={11} />
                    <div className={classes.wrapField}>
                      <InputLabel>Shares owned by applicant (Baht)</InputLabel>
                      <TextField
                        disabled={!canEdit}
                        variant="outlined"
                        className={classes.textField}
                        name="ValuePerShare"
                        value={formik.values.ValuePerShare}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("ValuePerShare", formik)}
                        helperText={getErrorMessage("ValuePerShare", formik)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell>
                  <div className={classes.cellContent}>
                    <Bagde number={12} />
                    <div className={classes.wrapField}>
                      <InputLabel>Shares owned by applicant (Baht)</InputLabel>
                      <TextField
                        disabled={!canEdit}
                        variant="outlined"
                        className={classes.textField}
                        name="SharesOwned"
                        value={formik.values.SharesOwned}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("SharesOwned", formik)}
                        helperText={getErrorMessage("SharesOwned", formik)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <Bagde number={13} />
                    <div className={classes.wrapField}>
                      <InputLabel>
                        Please select the core technology used in the production
                        process or services provision
                      </InputLabel>
                      <FormControl
                        variant="outlined"
                        className={classes.formControl}
                        error={isError("ProcessDiagram", formik)}
                        style={{ width: 750 }}
                      >
                        <InputLabel>
                          Selected the the core technology used in the
                          production process or services provision
                        </InputLabel>
                        <Select
                          disabled={!canEdit}
                          label="Selected the the core technology used in the production process or services provision"
                          name="assignmentId"
                          value={formik.values.assignmentId}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        >
                          {assignmentConfig.map((assignment) => (
                            <MenuItem
                              value={assignment.assignmentId}
                              key={assignment.assignmentId}
                            >
                              {assignment.assignmentName}
                            </MenuItem>
                          ))}
                        </Select>
                        <FormHelperText
                          error={isError("ProcessDiagram", formik)}
                        >
                          {getErrorMessage("ProcessDiagram", formik)}
                        </FormHelperText>
                      </FormControl>
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <Bagde number={14} />
                    <div className={classes.wrapField}>
                      <InputLabel>Acquisition of core technology</InputLabel>
                      <FormGroup row>
                        {technologyCoreConfig.map((technologyCore) => (
                          <FormControlLabel
                            key={technologyCore.technologyCoreID}
                            control={
                              <StyleCheckbox
                                disabled={!canEdit}
                                name={technologyCore.technologyCoreName}
                                value={technologyCore.technologyCoreID}
                                checked={
                                  formik.values.technologyCore ===
                                  technologyCore.technologyCoreID
                                }
                                onClick={() => {
                                  formik.setFieldValue(
                                    "technologyCore",
                                    technologyCore.technologyCoreID
                                  );
                                }}
                              />
                            }
                            label={technologyCore.technologyCoreName}
                          />
                        ))}
                      </FormGroup>
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <Bagde number={0} />
                    <div className={classes.wrapField}>
                      <InputLabel>Please explain</InputLabel>
                      <TextField
                        disabled={!canEdit}
                        variant="outlined"
                        className={classes.textField}
                        name="technologyCoreExplain"
                        value={formik.values.technologyCoreExplain}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("technologyCoreExplain", formik)}
                        helperText={getErrorMessage(
                          "technologyCoreExplain",
                          formik
                        )}
                        multiline
                        rows={5}
                        rowsMin={5}
                        rowsMax={5}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <Bagde number={15} />
                    <div className={classes.wrapField}>
                      <InputLabel>
                        Objective of technology employment
                      </InputLabel>
                      <FormGroup row>
                        {technologyEmploymentConfig.map(
                          (technologyEmployment) => (
                            <FormControlLabel
                              key={technologyEmployment.technologyEmploymentID}
                              control={
                                <StyleCheckbox
                                  disabled={!canEdit}
                                  name={
                                    technologyEmployment.technologyEmploymentName
                                  }
                                  value={
                                    technologyEmployment.technologyEmploymentID
                                  }
                                  checked={
                                    formik.values.technologyEmployment ===
                                    technologyEmployment.technologyEmploymentID
                                  }
                                  onClick={() => {
                                    formik.setFieldValue(
                                      "technologyEmployment",
                                      technologyEmployment.technologyEmploymentID
                                    );
                                  }}
                                />
                              }
                              label={
                                technologyEmployment.technologyEmploymentName
                              }
                            />
                          )
                        )}
                      </FormGroup>
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <Bagde number={0} />
                    <div className={classes.wrapField}>
                      <InputLabel>Please explain</InputLabel>
                      <TextField
                        disabled={!canEdit}
                        variant="outlined"
                        className={classes.textField}
                        name="technologyEmploymentExplain"
                        value={formik.values.technologyEmploymentExplain}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("technologyEmploymentExplain", formik)}
                        helperText={getErrorMessage(
                          "technologyEmploymentExplain",
                          formik
                        )}
                        multiline
                        rows={5}
                        rowsMin={5}
                        rowsMax={5}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <div />
            </TableBody>
          </Table>
        </TableContainer>

        <ButtonController
          onClickSaveDraft={() => {
            if (!canEdit) {
              dispatch(setSmartFormStep(SMART_T_STEP.VISA_INSUANCE));
              return;
            }
            setSaveDraft(true);
            callAPISubmit(formik.values);
          }}
        />
      </form>
    </div>
  );
}
